import { Form, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function AddressDetails(props) {

    let contactAccount = props.contactAccount
    const { data: countryList } = request.core.swrCountries()
    const { data: stateListData } = request.core.swrStates({country_id: contactAccount && contactAccount.contact.profile.country_id ? contactAccount.contact.profile.country_id : ""})
    const { data: fullStateList } = request.core.swrStates()

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [showUpdate, setShowUpdate] = useState(false);
    const [stateList, setStateList] = useState();
    const [completestateList, setCompleteStateList] = useState();
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [data, setData] = useState({ 
        street: null,
        city: null,
        country_id: null,
        province_id: null,
        zip_code: null,
    })

    useEffect(() => {
        setStateList(stateListData)
        setCompleteStateList(fullStateList)

        if(typeof contactAccount != 'undefined'){
            setData({ 
                street: contactAccount && contactAccount.contact.profile.street != "" ? contactAccount.contact.profile.street : "",
                city: contactAccount && contactAccount.contact.profile.city != "" ? contactAccount.contact.profile.city : "",
                country_id: contactAccount && contactAccount.contact.profile.country_id,
                province_id: contactAccount && contactAccount.contact.profile.province_id,
                zip_code: contactAccount && contactAccount.contact.profile.zip_code != "" ? contactAccount.contact.profile.zip_code : "",
            })

            setContactId(contactAccount.contact_id)
        }
        

    }, [stateListData, fullStateList]);

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    const getStates = (e) => {
        let newList = [];
        completestateList.map(d => {
            d.country.id == e.target.value ? newList.push({id: d.id, name: d.name}) : ""
        })
        setStateList(newList)

        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        let res = await request.contacts.updateAddressProfile({...data, contact_id: contactId});
        console.log(res)
        if(res.err){
            onError('Kindly fill up all the fields before saving.')
        }else{
            onSuccess('Successfully updated address details.')
            onClickCancel()
        }
    }

    const onSuccess = (message) => 
    {
        setSuccessMessage(message);
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    const onError = (message) => 
    {
        setSuccessMessage(''); // Clear success message if any
        setErrorMessage(message); 
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    return (
        <div className="addressDetails py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Address</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextStreet">
                            <Form.Label column md="3" className="text-md-right">Street</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" name="street" className="rounded-0" value={data.street} onChange={handleChange} readOnly={readOnly}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextCity">
                            <Form.Label column md="3" className="text-md-right">City/Town</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" name="city" className="rounded-0" value={data.city} onChange={handleChange} readOnly={readOnly}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextState">
                            <Form.Label column md="3" className="text-md-right">Country</Form.Label>
                            <Col md="7">
                                <Form.Control 
                                    as="select" 
                                    custom 
                                    onChange = {getStates}
                                    disabled={readOnly}
                                    name="country_id"
                                >
                                    <option value="">Select</option>
                                    {countryList ? 
                                        Object.keys(countryList).map((keyName, i) => (
                                            data.country_id == countryList[keyName]['id'] ? 
                                            <> <option key={countryList[keyName]['id']} value={countryList[keyName]['id']} selected>{countryList[keyName]['name']}</option> </> 
                                            : <> <option key={countryList[keyName]['id']} value={countryList[keyName]['id']}>{countryList[keyName]['name']}</option> </>
                                        )) : <> <option value="">Select</option> </>
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextState">
                            <Form.Label column md="3" className="text-md-right">State/Province</Form.Label>
                            <Col md="7">
                                <Form.Control 
                                    as="select" 
                                    custom 
                                    disabled={readOnly}
                                    name="province_id"
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    {stateList ? 
                                        Object.keys(stateList).map((keyName, i) => (
                                            data.province_id == stateList[keyName]['id'] ? 
                                            <> <option key={stateList[keyName]['id']} value={stateList[keyName]['id']} selected>{stateList[keyName]['name']}</option> </> 
                                            : <> <option key={stateList[keyName]['id']} value={stateList[keyName]['id']}>{stateList[keyName]['name']}</option> </>                                            
                                        )) : <> <option value="">Select</option> </>
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextPostal" className="mb-4">
                            <Form.Label column md="3" className="text-md-right">Zip/Postal</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" name="zip_code" className="rounded-0" value={data.zip_code} onChange={handleChange} readOnly={readOnly}/>
                            </Col>                   
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextOther">
                            <Form.Label column md="3"></Form.Label>
                            <Col md="7">
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default AddressDetails
